import axios from 'axios';

export default {
  namespaced: true,

  state: {
    documents: [],
  },

  getters: {
    documents(state) {
      return state.documents;
    },
  },

  mutations: {
    setDocuments(state, value) {
      state.documents = value;
    },
    addDocument(state, value) {
      state.documents.push(value);
    },
    removeDocument(state, id) {
      state.documents = state.documents.filter((d) => d.id !== id);
    },
  },

  actions: {
    async getDocuments({ commit }) {
      const { data } = await axios.get('/api/documents');
      commit('setDocuments', data);
    },
    async postDocument({ commit }, document) {
      const { data } = await axios.post('/api/documents', document);
      commit('addDocument', data);
    },
    async deleteDocument({ commit }, id) {
      await axios.delete(`/api/documents/${id}`);
      commit('removeDocument', id);
    },
  },

};
